import React, { useEffect } from 'react';
import './SharedPages.css';

function LegalPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">Mentions Légales</h1>
          <p className="page-subtitle">
            Informations juridiques concernant l'éditeur du site et de l'application CrousRadar.
          </p>
        </div>

        <div className="page-content">
          <h2>1. Éditeur du service</h2>
          <p>
            Le site web et l'application CrousRadar sont édités de manière indépendante par le Groupe Christophe NICOLAS - SIREN 924175714<br />
            CrousRadar est un service non officiel, indépendant du réseau des CROUS régionaux et du CNOUS.
          </p>

          <h2>2. Hébergement</h2>
          <p>
            L'hébergement du site est assuré par Firebase Hosting / Google Cloud France SARL
            8 rue de Londres, 75009 Paris - SIREN 881721583.<br />
            Les données de l'application sont hébergées de manière sécurisée (Google Firebase / Vercel).
          </p>

          <h2>3. Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments figurant sur le site et l'application (textes, graphismes, logos, icônes) est protégé par les dispositions du Code de la Propriété Intellectuelle. Toute reproduction, modification ou diffusion totale ou partielle du contenu est formellement interdite sans l'autorisation expresse des éditeurs.
          </p>

          <h2>4. Contact</h2>
          <p>
            Pour toute demande ou signalement, veuillez nous contacter à l'adresse suivante : <strong>contact@crousradar.fr</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LegalPage;
